import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { initPostHog } from "@handshake/core-fe";
import { environment } from "@environments/environment";
import { loadPaymentFeatureFlags } from "./app/core/config/payment-feature-flags";

initPostHog(environment.posthog);

loadPaymentFeatureFlags(environment.apiUrl)
  .catch(() => undefined)
  .finally(() => {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  });
